import { P, match } from 'ts-pattern'

import type { TextContent } from '@flows/core/i18n/types'

export const resolveStepContentElementValue = (
  value: string | number | TextContent | undefined,
  processText: (element: TextContent) => string
): string | undefined => {
  return match(value)
    .with(P.nullish, () => undefined)
    .with(P.union(P.string, P.number), (plainValue) => plainValue.toString())
    .otherwise((textContent) => processText(textContent))
}
